import React from "react";
import classNames from "classnames";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { styles } from "./style";

interface OwnProps {
	color: string;
	/** When set, the swatch is a button, e.g. to open a picker. */
	onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
	label?: string;
}

interface Props extends OwnProps, WithStyles<typeof styles> {}

const Component: React.FC<Props> = ({ classes = {}, color, onClick, label }) => {
	if (onClick) {
		return (
			<button
				type="button"
				className={classNames(classes.swatch, classes.button)}
				style={{ backgroundColor: color }}
				onClick={onClick}
				aria-label={label}
				title={label}
			/>
		);
	}
	return <span className={classes.swatch} style={{ backgroundColor: color }} aria-hidden="true" />;
};

export const ColorSwatch = withStyles(Component, styles);
